import React, { useEffect, useState, useRef } from 'react';

import { DataGrid } from '@mui/x-data-grid';
import { Card } from '@sunwisesoftware/sunwise-ui';
import { debounce, isEqual } from 'lodash';
import PropTypes from 'prop-types';

import { CustomPagination } from 'common/components';
import { DEBOUNCE_TIME_500, TABLE_PAGE_SIZE_OPTIONS } from 'common/constants';
import CustomColumns from 'common/modules/customColumns';
import { getOrderedColumns, getHiddenColumns } from 'common/utils/helpers';

import { COLUMNS_CONFIG } from '../constants';

import ProductColumns from './ProductColumns';

const ListItems = ({
    filterData,
    filterItems,
    isFetching,
    items,
    setFilterData,
    tableSettings,
}) => {
    const [currentFilterData, setCurrentFilterData] = useState(filterData);

    const handleOnFilter = useRef(
        debounce((filter) => filterItems(filter), DEBOUNCE_TIME_500),
    ).current;

    const pageSizeOptions = TABLE_PAGE_SIZE_OPTIONS;

    const columns = ProductColumns({
        hiddenColumns: getHiddenColumns(tableSettings),
        orders: getOrderedColumns(tableSettings),
    });

    const getRowHeight = () => 'auto';
    const columnVisibilityModel = columns.reduce(
        (acc, column) => ({ ...acc, [column.field]: !column.hide }),
        {},
    );
    const initialState = {
        pagination: { paginationModel: { pageSize: pageSizeOptions[0] } },
    };
    const onSortModelChange = (model) => {
        if (!model[0]) return;
        setFilterData((prev) => ({
            ...prev,
            orderBy: model[0].field.toLocaleLowerCase(),
            sortBy: model[0].sort,
        }));
    };
    const slotProps = {
        pagination: {
            customContent: (
                <CustomColumns.Container
                    columnsConfig={COLUMNS_CONFIG}
                    tableKey="racking"
                />
            ),
            pageSizeOptions,
        },
    };
    const slots = { pagination: CustomPagination };

    useEffect(() => {
        if (isEqual(currentFilterData, filterData)) return;
        handleOnFilter(filterData);
        setCurrentFilterData(filterData);
    }, [filterData]);

    return (
        <Card>
            <Card.Body>
                <DataGrid
                    columns={columns}
                    columnVisibilityModel={columnVisibilityModel}
                    disableColumnMenu
                    disableRowSelectionOnClick
                    getRowHeight={getRowHeight}
                    hideFooterSelectedRowCount
                    initialState={initialState}
                    loading={isFetching}
                    onSortModelChange={onSortModelChange}
                    pageSizeOptions={pageSizeOptions}
                    rows={items}
                    slots={slots}
                    slotProps={slotProps}
                />
            </Card.Body>
        </Card>
    );
};

ListItems.propTypes = {
    filterData: PropTypes.object,
    filterItems: PropTypes.func,
    isFetching: PropTypes.bool,
    items: PropTypes.array,
    setFilterData: PropTypes.func,
    tableSettings: PropTypes.array,
};

export default ListItems;
